/**
 * Conversionのカテゴリー
 */
export const ConversionCategories = {
  // プリペイドポイント
  prepaidPoint: 'prepaid_point',
  gachaTicket: 'gacha_ticket',
  storeItem: 'store_item',
  preSaleItem: 'preSale_item',
}

/**
 * Conversionアイテムが表示されるリスト
 */
export const ConversionListName = {
  // 購入可能プリペイドポイントリスト
  purchasablePrepaidPointList: 'purchasable_prepaid_point_list',
}
